<template>
    <footer>
        <small>
            Copyright © {{ new Date().getFullYear() }} Delta Plastics - Preserving Our Farmland. All rights reserved.&nbsp;
            /&nbsp; <a target="_blank" href="https://www.deltaplastics.com/privacy-policy" rel="noopener">Privacy Policy</a> / <a href=""
                @click.prevent="toggleLicensesDiv">Licenses</a>

            <div ref="licenses_div" class="hidden licenses_div">
                <a target="_blank" rel="license" href="/fonts/ROBOTO_LICENSE.txt">Roboto Font License</a><br>
                <a target="_blank" rel="license" href="http://scripts.sil.org/OFL">Font Awesome Font License (SIL OFL
                    1.1)</a><br>
                <a target="_blank" rel="license" href="http://opensource.org/licenses/mit-license.html">Font Awesome CSS
                    License (MIT)</a><br>

                <div v-for="license in licenses" :key="license.nodeModule">
                    <a target="_blank" rel="license" :href="license.licenseUrl">
                        {{ license.nodeModule }}
                    </a>
                </div>
            </div>
        </small>
    </footer>
</template>

<script setup>
import { ref, reactive, computed } from 'vue'

const licenses_div = ref(null)

const data = reactive({
    licensesJson: null
})

const licenses = computed(() => {
    const ret = []

    if(! data.licensesJson) {
        return []
    }

    for (let key in data.licensesJson) {
        const license = data.licensesJson[key]

        if (key.match(/^[@]pp4/)) {
            continue
        }

        ret.push({
            nodeModule: key,
            licenseUrl: license.licenseUrl
        })
    }

    return ret
})

async function fetchLicenses() {
    if(data.licensesJson) {
        return
    }
    
    data.licensesJson = (await import('@/assets/licenses')).default
}

function toggleLicensesDiv() {
    const div = licenses_div.value

    if (div?.classList.contains('hidden')) {
        fetchLicenses()
        div.classList.remove('hidden')
    }
    else {
        div?.classList.add('hidden')
    }
}
</script>

<style lang="css" scoped>
footer {
    display: block;
    color: var(--primary);
    background-color: var(--bg0);
    padding: var(--general-padding);
    margin-top: var(--general-padding);
    position: sticky;
    bottom: 0px;
    border-top: 2px solid var(--fg2);
}

footer a {
    color: var(--primary);
}

.licenses_div {
    max-height: 20vh;
    margin-left: var(--general-padding);
    overflow: auto;
}
</style>
